export interface IAppConfiguration {
  portalUrl: string;
  ratUrl: string;
  deploymentTypeCode: string;
}

export enum IAppConfigType {
  TEST,
  PILOT,
  PROD,
}
